import React, { Component, PropTypes } from 'react';
import './userImage.scss';

import ApiService from 'service/ApiService';

import FaUser from 'react-icons/lib/fa/user';


export default class UserImage extends Component {
    render() {
        return (
            <div className={`user-image ${this.props.className ? this.props.className : ''}`}>
                <If condition={this.props.user.image}>
                    <img className="user-image-custom" src={ApiService.getApiUrl(`/users/image/${this.props.user.id}`)} />
                <Else />
                    <FaUser className="user-image-default" />
                </If>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/views/userImage/UserImage.js